import NotificationsForLeadsFilters from './NotificationsForLeadsFilters.component';

export default NotificationsForLeadsFilters;
